import styled from 'styled-components';
import { PROMOTION_YELLOW } from '../../constants';

const SELECTORS = ', .pt_content #primary';
const TABLET_BREAKPOINT = '1280px';
const MIN_PRICE_BANNER_SIZE = '850px';

export const PriceBannerBlockContainer = styled.div`
    ${SELECTORS} & {
        position: relative;
        background-color: #1f2226;
    }
    @media (max-width: ${TABLET_BREAKPOINT}) {
        ${SELECTORS} & {
            max-height: 460px;
            overflow: hidden;
        }
    }
`;

export const SubscriptionPriceContainer = styled.div`
    ${SELECTORS} & {
        p {
            color: white;
            text-align: center;
            margin: 0;
        }
    }
`;

export const PriceBannerImageContainer = styled.div`
    ${SELECTORS} & {
        display: inline-block;
        width: 100%;
        height: auto;
        margin: auto;
        overflow: hidden;
        img {
            max-width: unset;
            width: 100%;
        }
    }
    @media (max-width: 1500px) {
        ${SELECTORS} & {
            img {
                width: unset;
            }
        }
    }
    @media (max-width: ${MIN_PRICE_BANNER_SIZE}) {
        ${SELECTORS} & {
            img {
                width: 100%;
            }
        }
    }
`;

export const PriceBannerInformationContainer = styled.div`
    ${SELECTORS} & {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    @media (max-width: ${MIN_PRICE_BANNER_SIZE}) {
        ${SELECTORS} & {
            width: 70%;
        }
    }
`;

export const PriceBannerCountdownContainer = styled.div`
    ${SELECTORS} & {
        margin-bottom: 20px;
    }
`;

export const UbisoftPlusLogoContainer = styled.div`
    ${SELECTORS} & {
        width: fit-content;
        margin: auto auto 20px auto;
        svg {
            display: inline-block;
            width: 349px;
            height: 66px;
        }
    }

    @media (max-width: ${TABLET_BREAKPOINT}) {
        ${SELECTORS} & {
            svg {
                width: 262px;
                height: 43px;
            }
        }
    }

    @media (max-width: ${MIN_PRICE_BANNER_SIZE}) {
        ${SELECTORS} & {
            svg {
                width: 192px;
                height: 31px;
            }
        }
    }
`;

export const PriceBannerDescription = styled.p`
    ${SELECTORS} & {
        font-size: 40px;
        line-height: 48px;
        text-align: center;
        margin-bottom: 20px;
        color: white;

        //Font-family setup
        font-family: ${(props) => props.theme.boldFont};
        font-weight: ${(props) => props.theme.fontWeight};
        span {
            font-size: 40px;
            line-height: 48px;
            font-family: ${(props) => props.theme.boldFont};
            font-weight: ${(props) => props.theme.fontWeight};
        }
    }
    @media (max-width: ${TABLET_BREAKPOINT}) {
        ${SELECTORS} & {
            font-size: 20px;
            line-height: 24px;
            margin-bottom: 20px;

            span {
                font-size: 20px;
                line-height: 24px;
            }
        }
    }
`;

export const PrinceTextContainer = styled.div`
    ${SELECTORS} & {
        display: flex;
        justify-content: center;
        align-items: baseline;
        margin-bottom: 20px;
    }
`;

export const SubscriptionPriceText = styled.p`
    ${SELECTORS} & {
        font-size: 50px;
        line-height: 50px;
        margin-bottom: 0;
    }

    @media (max-width: ${TABLET_BREAKPOINT}) {
        ${SELECTORS} & {
            font-size: 30px;
        }
    }
`;

export const PriceMonthText = styled.p`
    ${SELECTORS} & {
        font-size: 30px;
        text-align: center;
        color: white;
        line-height: 45px;
        margin-bottom: 2px;
    }
    @media (max-width: ${TABLET_BREAKPOINT}) {
        ${SELECTORS} & {
            font-size: 20px;
            line-height: 24px;
        }
    }
`;

export const PriceBannerPriceContainer = styled.div`
    ${SELECTORS} & {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-content: center;
    }
`

export const PriceBannerSubscriptionButton = styled.div`
    ${SELECTORS} & {
        margin: auto;
        width: fit-content;
    }
    @media (max-width: ${TABLET_BREAKPOINT}) {
        ${SELECTORS} & {
            margin: auto;
            width: 100%;
            #restriction-info {
                width: 100%;
            }
        }
    }
`;
